import { Injectable } from '@angular/core';
import { PartnerStore } from './partner.store';
import { Partner } from './partner.model';
import { tap, mapTo, switchMapTo } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';

@Injectable({ providedIn: 'root' })
export class PartnerService {
  constructor(
    private partnerStore: PartnerStore,
    private api: ApiService
  ) {}

  fetchPartners() {
    return this.api.get<Partner>('partners').pipe(
      tap((entities) => {
        this.partnerStore.set(entities);
      }),
      mapTo(null)
    );
  }

  confirmPartner(partnerCode: string, partnerSecretCode: string) {
    return this.api.post('partners/processInvite', { partnerCode, partnerSecretCode }).pipe(switchMapTo(this.fetchPartners()));
  }

  remove(id: number) {
    return this.api.delete(`partners/remove`, `${id}`).pipe(tap(() => this.partnerStore.remove(id)));
  }

  getPartnerLimit() {
    return this.api.getAnySingle<number>('partners/partnerLimit');
  }
  getFriendLink() {
    return this.api.get('partners/friend/link');
  }

  sendReferFriendLink(email: string, fullname: string) {
    let friendsDetails = {
      FullName: fullname,
      PartnerEmail: email,
    };
    return this.api.post(`partners/friend/email?emailAddress=${email}&fullName=${fullname}`, friendsDetails).pipe(tap((x) => {}));
  }
}
